import './HomeCookTogether.css'
import homeCookImage from '../../../assets/images/home_cook-together-image.webp'
import decorRight from '../../../assets/images/home_cook-together-decor-right.webp'
import decorLeft from '../../../assets/images/home_cook-together-decor-left.webp'
import { Link } from 'react-router-dom'

const HomeCookTogether = () => {
  return (
    <section className='home__cook-together-section'>
        <img src={decorRight} alt="декор" className="home__cook-together-decor-right" />
        <img src={decorLeft} alt="декор" className="home__cook-together-decor-left" />
        <h2 className="home__cook-together-title mont-m">Готуйте разом з нами</h2>
        <p className="home__cook-together-text int-r-21">Молочна продукція — це безмежне поле для кулінарної творчості. Вершки, масло, сири, йогурти — усе це надихає створювати домашні шедеври. Заходьте за ідеями та рецептами на наш сайт та соціальні мережі.</p>
    <img src={homeCookImage} alt="Готуйте разом з нами" className="home_cook-together-image" />
    <Link to={"/recipes"} className='home__cook-together-link int-r-21'>Перейти до рецептів</Link>
    </section>
  )
}

export default HomeCookTogether